export default "__VITE_ASSET__d0ef68ec__"